import LabServiceModel from "@/models/LabServiceModel";

export default class AttributeListKinModel extends LabServiceModel {
  modelName() {
    return "kin";
  }
  defaults() {
    return {
      id: null,
      managed_list_id: null,
      parent_id: null,
      value: null,
      default: null,
      created_at: null,
      updated_at: null,
      deleted_at: null
    };
  }
  mutations() {
    return {
      id: val => this.nullStringMutator(val),
      managed_list_id: val => this.nullStringMutator(val),
      parent_id: val => this.nullStringMutator(val),
      value: val => this.nullStringMutator(val),
      default: val => this.nullStringMutator(val),
      created_at: val => this.nullStringMutator(val),
      updated_at: val => this.nullStringMutator(val),
      deleted_at: val => this.nullStringMutator(val)
    };
  }
  validation() {
    return {};
  }
}
